// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cta-button[data-v-7c287c65]{display:inline-flex;align-items:center;justify-content:center;border-radius:9999px;--tw-bg-opacity:1;background-color:rgb(38 94 245 / var(--tw-bg-opacity, 1));padding-top:5.5px;padding-bottom:5.5px;padding-left:32.5px;padding-right:32.5px;font-size:.9375rem;font-weight:500;line-height:1.875rem;--tw-text-opacity:1;color:rgb(255 255 255 / var(--tw-text-opacity, 1));-webkit-text-decoration-line:none;text-decoration-line:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
